document.addEventListener('DOMContentLoaded', function() {
  BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', function(event) {
    
document.querySelector('.shopify-product-form').addEventListener('change',()=>{
  let inputs = document.querySelectorAll('.bold_option_element input[name^="properties"]');
  inputs.forEach((input)=>{
    let char = input.name.charAt(input.name.length - 2);
    console.log(char);
    if (!isNaN(parseInt(char))){
      let index = input.name.indexOf(char);
      input.name = input.name.slice(0, index) + input.name.slice(index + 1);
      console.log(input.name);
    }
  })
})


    
    console.log('Event emitted: BOLD_OPTIONS_option_products_loaded');
    var optionsDiv = document.querySelector('.bold_options_loaded');
    if (optionsDiv && optionsDiv.children.length !== 0) {
      // Select both swatch and checkbox elements
      const swatchElements = document.querySelectorAll('.bold_option.bold_option_swatch, .bold_option.bold_option_checkbox');
      // Loop through each swatch or checkbox element
      swatchElements.forEach(element => {
        // Find the span with the class .bold_option_title inside .bold_option
        const titleSpan = element.querySelector('span.bold_option_title');
        // If found, remove numbers only if they are at the end of the text content
        if (titleSpan) {
          // Use a regular expression to remove numbers only at the end of the text
          titleSpan.textContent = titleSpan.textContent.replace(/\d+$/, '');
        }
      });
      document.querySelectorAll('.bold_option.bold_option_dropdownmulti .bold_option_title').forEach(function(title) {
    title.innerHTML = title.innerHTML.replace(/\d+/g, '');  // Removes all numbers from the text
});

    }
  });
});
